module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.a32fa1f2.eot";